import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { SignUpConfirmPage } from 'features/auth'
import { z } from 'zod/v4'

const signUpConfirmSearchSchema = z.object({
  confirmationCode: z.coerce.string().optional(),
})

export type SignUpConfirmSearch = z.infer<typeof signUpConfirmSearchSchema>

export const Route = createFileRoute('/signup/confirm/$signupIntent')({
  component: Page,
  validateSearch: signUpConfirmSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Sign Up'),
      },
    ],
  }),
})

function Page() {
  const { signupIntent } = Route.useParams()
  const { confirmationCode } = Route.useSearch()

  return <SignUpConfirmPage confirmationCode={confirmationCode} signupIntent={signupIntent} />
}
